import { sendGet, sendPost } from "@/api";

/**
 * Функция авторизации пользователя в системе
 * @param data - объект данных о пользователе (login, password)
 * @returns {Promise<*>}
 */
async function logInApi(data) {
    try {
        return await sendPost(`auth/login`, data);
    } catch (error) {
        console.log("ERROR!!! - logIn", error);
        throw error;
    }
}

/**
 * Функция выхода пользователя из системы
 * @returns {Promise<*>}
 */
async function logOutApi() {
    try {
        return await sendPost(`auth/logout`);
    } catch (error) {
        console.log("ERROR!!! - logInAPI", error);
        throw error;
    }
}
/**
 * Функция получения информации о пользователе
 * @returns {Promise<*>}
 */
async function whoAmIApi() {
    try {
        return await sendGet(`auth/users/whoami`);
    } catch (error) {
        console.log("ERROR!!! - whoAmIApi", error);
        throw error;
    }
}

/**
 * Функция обновления токена
 * @returns {Promise<*>}
 */
async function refreshLoginApi() {
    try {
        return await sendGet(`auth/refresh`);
    } catch (error) {
        console.log("ERROR!!! - refreshLoginApi", error);
        throw error;
    }
}

export { logInApi, logOutApi, whoAmIApi, refreshLoginApi };
